declare const VueComponents: {
	BottomRightToast: {
		open: (props: Record<string, unknown>, events: Array<{ eventName: string; eventHandler: (...args: unknown[]) => void }>) => void;
		close: () => void;
	};
};

export interface IdentifySubmitterToastItem {
	prefix: string;
	link: string;
	onClick?: () => void;
}

export interface IdentifySubmitterToastSection {
	fieldHeader?: { name: string; suffix?: string };
	header?: string;
	submitterSummary?: string;
	items?: IdentifySubmitterToastItem[];
}

export interface IdentifySubmitterToastData {
	sections: IdentifySubmitterToastSection[];
	showEdit?: boolean;
}

/**
 * Show a bottom-right toast with action buttons using the BottomRightToast Vue component.
 * The component renders the message with an icon and Edit/Got It buttons via slots.
 */
export function showPersonFieldToast(message: string, onEdit: () => void): void {
	VueComponents.BottomRightToast.open({
		title: message,
		icon: 'identify-submitter'
	}, [{ eventName: 'secondary', eventHandler: onEdit }]);
}

/**
 * Show a simple success notification in bottom-right corner.
 */
export function showSuccessToast(message: string): void {
	VueComponents.BottomRightToast.open({
		title: message,
		showClose: true
	}, []);
}

export function dismissBottomRightToast(): void {
	if (typeof VueComponents !== 'undefined')
		VueComponents.BottomRightToast.close();
}

let _suppressWorkflowLinkAuthNotification = false;

export function suppressWorkflowLinkAuthNotification(): void {
	_suppressWorkflowLinkAuthNotification = true;
	setTimeout(() => { _suppressWorkflowLinkAuthNotification = false; }, 0);
}

export function isWorkflowLinkAuthNotificationSuppressed(): boolean {
	const val = _suppressWorkflowLinkAuthNotification;
	if (val) _suppressWorkflowLinkAuthNotification = false;
	return val;
}

export function showIdentifySubmitterAutoConfigToast(data: IdentifySubmitterToastData, onEdit: () => void): void {
	const soloEditButton = data.sections.length === 1 && data.sections[0].items?.length === 1;
	VueComponents.BottomRightToast.open({
		title: 'Track Submissions By Person',
		identifySubmitterData: data,
		icon: 'identify-submitter',
		secondaryAction: soloEditButton ? 'Edit' : '',
		onSecondaryClick: soloEditButton ? onEdit : null,
		show: true
	}, []);
}
